import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full pt-8 lg:pt-0"
}
const _hoisted_2 = { class: "mt-4 lg:mt-6" }

import { computed } from 'vue'
import { UiHeading, UiContainer } from '@/components/common/ui'
import { AppLoadingContent, TheFallback } from '@/components/common'
import AdviceStatusLabel from '@/components/advices/AdviceStatusLabel.vue'
import AdviceDetails from '@/components/advices/AdviceDetails.vue'
import AdviceDetailsActions from '@/components/advices/AdviceDetailsActions.vue'
import AdviceDeliveryReactions from '@/components/advices/AdviceDeliveryReactions.vue'
import { useAdvices } from '@/composables/useAdvices'
import { useAdviceDeliveryReactions } from '@/composables/useAdviceDeliveryReactions'

type Props = {
    adviceId: string
}

export default /*#__PURE__*/_defineComponent({
  props: {
    adviceId: { type: String, required: true }
  },
  setup(__props: any) {

const props = __props as {
    adviceId: string
}


const { fetchAdviceDetails, loading: isLoadingAdvices, adviceDetails } = useAdvices()
fetchAdviceDetails(Number(props.adviceId))

const {
    fetchAdviceDeliveryReactions,
    loading: isLoadingAdviceDeliveryReactions,
    adviceDeliveryReactions,
} = useAdviceDeliveryReactions()
fetchAdviceDeliveryReactions(Number(props.adviceId))

const loading = computed(() => isLoadingAdvices.value && isLoadingAdviceDeliveryReactions.value)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(UiHeading), {
      title: _unref(adviceDetails).axId,
      "can-go-back": ""
    }, {
      default: _withCtx(() => [
        (!_unref(isLoadingAdvices))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(AdviceStatusLabel, {
                class: "lg:ml-10",
                status: _unref(adviceDetails).adviceStatus
              }, null, 8, ["status"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_unref(UiContainer), null, {
      default: _withCtx(() => [
        _createVNode(_unref(AppLoadingContent), { "is-loading": _unref(loading) }, {
          default: _withCtx(() => [
            (Object.keys(_unref(adviceDetails)).length === 0)
              ? (_openBlock(), _createBlock(_unref(TheFallback), { key: 0 }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(AdviceDetailsActions, { "advice-details": _unref(adviceDetails) }, null, 8, ["advice-details"]),
                  _createVNode(AdviceDetails, { "advice-details": _unref(adviceDetails) }, null, 8, ["advice-details"]),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(AdviceDeliveryReactions, {
                      "advice-id": Number(props.adviceId),
                      "advice-delivery-reactions": _unref(adviceDeliveryReactions).items
                    }, null, 8, ["advice-id", "advice-delivery-reactions"])
                  ])
                ], 64))
          ]),
          _: 1
        }, 8, ["is-loading"])
      ]),
      _: 1
    })
  ], 64))
}
}

})